import type {CSSProperties} from 'react';

import css from './LoadingPing.module.scss';

export type LoadingPingProps = {
  size?: number;
  color?: CSSProperties['color'];
};

export const LoadingPing = ({size = 18, color = 'white'}: LoadingPingProps) => {
  return (
    <div
      className={css.ping}
      style={
        {
          '--size': `${size}px`,
          '--color': color,
        } as CSSProperties
      }
    />
  );
};
